import React from 'react';

import { CDashboard } from 'components/Visualization';

import { inventorySummaryWidgets } from './config';

export const S3Summary = () => {
  return <CDashboard dashboardWidgets={inventorySummaryWidgets} />;
};
